export const APP_HEADER_HEIGHT = '50px';
export const MOBILE_APP_HEADER_HEIGHT = '40px';
export const CARD_HEIGHT = '40px';
export const SECTION_MARGIN = '8px';
export const ELEMENT_BORDER_RADIUS = '1px';
export const CREATE_ORDER_CARD_WIDTH = '282px';

export const Z_INDEX = {
	BASE: 1,
	DROPDOWN: 50,
	TOOLTIP: 100,
	BLUR_MODAL: 125,
	DROPDOWN_PANEL: 150,
	MODAL: 1400,
	APP_HEADER: 1000,
};

export const SEARCH_DEBOUNCE_MS = 300;
export const DEFAULT_REQUEST_REFRESH_INTERVAL = 30000; // 30s
export const SLIPPAGE_THRESHOLD = 0.1;
